import React from 'react';
import { EventRegistration, RegistrationField } from '../../../../../interfaces/interfaces';
import { linkify } from '../../../../../utils/functions';

export const ProfileRegistrationInfo = ({ registration }: { registration: EventRegistration }) => {
  function filterRegistrationFields(field: RegistrationField) {
    if (!registration) return false;

    const existsInAltSignUp = registration.signup && registration.signup?.registrationFields?.findIndex((f: RegistrationField) => f._id === field._id) !== -1;
    const parentField = registration.registrationFields.find((_field) => _field.field._id === field.parentField?.field);
    const isParentValid = !field.parentField?.field || parentField?.value === field.parentField?.value;

    return (field.isHidden !== true || existsInAltSignUp) && (!registration.signup || existsInAltSignUp) && !field.datetime_deleted && isParentValid;
  }

  if (!registration) return <></>;

  return (
    <div id="profilefields-info-mgmt" className="flex flex-col gap-3">
      {registration.registrationFields
        .filter(({ field }) => filterRegistrationFields(field))
        .filter(({ field }) => field.fieldType !== 'file')
        .map((o) => (
          <div className="w-full" key={`info-${o.field._id}`} id={`info-${o.field._id}`}>
            <b className="text-sm">{o.field.label}</b>
            {o.field.isURLField ? (
              <div dangerouslySetInnerHTML={{ __html: linkify(o.value, 'text-blue-500 hover:underline') }} />
            ) : (
              <p>{o.value.substring(0, 1) == ',' ? o.value.substring(1) : o.value.replace(/,/g, ', ')}</p>
            )}
          </div>
        ))}
    </div>
  );
};
